module.exports = __webpack_public_path__ + "img/poll.2607410d.jpg";